function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#62a949",
  d: "M244.93,246.19l.67.56-6.05,1.79.67-6.23.67.55.3-.36a.56.56,0,0,1-.12-.34v-.56a6.46,6.46,0,0,0,.47-.83,4.85,4.85,0,0,1,.38-.68,3.62,3.62,0,0,0,1.13-1.79,1.67,1.67,0,0,0-.16-1.31,9.88,9.88,0,0,0-.19-2.27,2.47,2.47,0,0,0-.58-1.8,1.74,1.74,0,0,0-1-.44,1.8,1.8,0,0,1-.38-.09,3.94,3.94,0,0,0-1.89-.5,4.4,4.4,0,0,0-3.9,2.68,6.57,6.57,0,0,0-.15,2l0,.39a1.78,1.78,0,0,0-.14,1.31,3.6,3.6,0,0,0,1.13,1.79,4.92,4.92,0,0,1,.38.68,6.8,6.8,0,0,0,.47.83v.56a.56.56,0,0,1-.45.55l-2.45.49a3.36,3.36,0,0,0-2.7,3.29v1.06a1.12,1.12,0,0,0,1.12,1.12h13.43a1.12,1.12,0,0,0,1.12-1.12v-1.06a3.33,3.33,0,0,0-.51-1.76Z",
  transform: "translate(-231 -231.88)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#75a0ce",
  fillRule: "evenodd",
  d: "M248.2,240.74l-2.5-2.06,1.56-1.86,2.5,2.06Zm-4.16,5-2.5-2.06,3.64-4.34,2.5,2.06Zm-3.33,1.45.31-2.89,2.5,2.06Z",
  transform: "translate(-231 -231.88)"
});

var SvgProfile = function SvgProfile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    viewBox: "0 0 18.76 16.79",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProfile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/profile.0968de2d.svg";
export { ForwardRef as ReactComponent };